export const LUGARES = [
  { value: 'Casco Antiguo', label: 'Casco Antiguo' },
  { value: 'Puerta Tierra', label: 'Puerta Tierra' },
];

export const ESTADOS = [
  { value: 'Notificada', label: 'Notificada', color: 'bg-sky-100 text-sky-800' },
  { value: 'Asignada', label: 'Asignada', color: 'bg-blue-100 text-blue-800' },
  { value: 'Realizada', label: 'Realizada', color: 'bg-green-100 text-green-800' },
  { value: 'Cancelada', label: 'Cancelada', color: 'bg-red-100 text-red-800' },
  { value: 'Ausente', label: 'Ausente', color: 'bg-orange-100 text-orange-800' },
];

export const MOTIVOS_CANCELACION = [
  { value: 'Uso Abusivo', label: 'Uso Abusivo' },
  { value: 'Otros', label: 'Otros' },
];

export const TIPOS_ENSER = [
  { value: 'Muebles/Enseres', label: 'Muebles/Enseres' },
  { value: 'Electrodomésticos', label: 'Electrodomésticos' },
];

export const MAX_ITEMS_PER_TICKET = 40;

export const TURNO_RECOGIDA = '07:00 - 13:00';

export const CANALES_RESPUESTA = [
  { value: 'Email', label: 'Email', icon: '📧' },
  { value: 'WhatsApp', label: 'WhatsApp', icon: '📱' },
  { value: 'Ambos', label: 'Ambos', icon: '📧📱' },
];

export const ELEMENTOS_COMUNES = {
  'Muebles/Enseres': [
    'Sofá',
    'Sillón',
    'Mesa',
    'Silla',
    'Cama',
    'Colchón',
    'Armario',
    'Estantería',
    'Otro'
  ],
  'Electrodomésticos': [
    'Nevera',
    'Lavadora',
    'Lavavajillas',
    'Horno',
    'Microondas',
    'Televisor',
    'Aire acondicionado',
    'Caldera',
    'Otro'
  ]
};
